import MessageLayout from './MessageLayout';
import letter from './../assets/Letter.png'
import cart from './../assets/Shopping-Cart.png'
import FullSermonView from './FullSermonView';

function FeaturedAudioView({ playlist, currentPlaylistItem, videoRef, isAdPlaying }) {
  console.log('Rendering FeaturedAudioView with ', playlist, currentPlaylistItem);

  const playlistItem = currentPlaylistItem?.seriesPage ? currentPlaylistItem : playlist[0];
  console.log('Derived playlistItem as ', playlistItem);
  
  let path = '';
  if (playlistItem?.seriesPage) {
    try {
      const url = new URL(playlistItem.seriesPage);
      path = url.pathname;
    } catch (error) {
      console.error('Invalid URL:', playlistItem.seriesPage, error);
      path = '';
    }
  }
  return (
    <div id="featured-audio-player" className={isAdPlaying ? 'ad-playing' : ''}>
      <div className='featured-audio-player-header'>
        <div className="video-container">
          <div data-vjs-player>
            <video ref={videoRef} poster={currentPlaylistItem?.poster} className="video-js vjs-big-play-centered" />
          </div>
        </div>
        {!(currentPlaylistItem?.messageSpeaker === 'Paws & Tales' && currentPlaylistItem?.playerType === 'single') && (
            <FullSermonView playlist={playlist} message={currentPlaylistItem} />
        )}
      </div>
    </div>
  );
}

export default FeaturedAudioView;   